import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_MASTERS_SAGA } from "../sagaTypes";
import { loadingAction, setScheduleAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';

const request = data => {
    return fetch(`${ url }/get_masters`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetMasters(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);
    const schedule = yield select(state => state.schedule);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('establishment', est.id);
        formData.append('date', schedule.date);
        formData.append('time', schedule.selected_time);
        formData.append('services', JSON.stringify(schedule.selected_services));

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setScheduleAction({
                ...schedule,
                open: true,
                stage: response.data.stage,
                masters: response.data.masters
            }));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetMasters() {
    yield takeLatest(GET_MASTERS_SAGA, workerGetMasters);
}